module.exports = __webpack_public_path__ + "static/hif-logo-f146c96a7b229513630a99f54e2aaf9a.png";